import React from "react";
import { FaTrash } from "react-icons/fa";
import CSButton from "./CSButton.jsx";

const DeleteButton = ({ className, title, ...props }) => (
  <CSButton
    {...props}
    className={`${className} `}
    title={title || "Delete"}
    aria-label={title || "Delete"}
    style={{ marginLeft: "0.1rem" }}
  >
    <FaTrash className="cs-icon" />
  </CSButton>
);

export default DeleteButton;
